import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import moment from 'moment';


/**
 * Alerts are urgent interruptions, requiring acknowledgement, that inform the user about a situation.
 */

 class TablesReports extends Component {


  render() {
    const {info} = this.props;
    return (
      <div style={{overflowY: 'auto'}}>
        <table className="table table-bordered table-striped table-hover">
         <thead>
           <tr>
             <th>Estado</th>
             <th>Cliente</th>
             <th>Proveedor</th>
             <th>Aduana de Despacho</th>
             <th>Tipo</th>
             <th>Pago del pedimento</th>
             <th>Fecha de arribo</th>
             <th>Fecha de Facturación</th>
             <th>Origen</th>
             <th>MAWB/MBL</th>
             <th>HAWB/HBL</th>
             <th>Valor Aduanal</th>
             <th>Numero del pedimento</th>
             <th>Vía</th>
             <th>Numero de Factura Comercial</th>
             <th>Aerolinea / Naviera / Carrier</th>
             <th>Bultos</th>
             <th>Peso</th>
             <th>Descripcion de la Mercancia</th>
             <th>Comentarios</th>
           </tr>
         </thead>
         <tbody>
          {info.map( (row, index) => (
           <tr key={index}>
               <td>{row.status}</td>
               <td>{row.customer.name}</td>
               <td>{row.supplier.name}</td>
               <td>{row.customsHouse.name}</td>
               <td>{row.type}</td>
               <td>{moment(row.requestingPaymentTimestamp).format('DD-MM-YYYY')}</td>
               <td>{moment(row.arrivalTimestamp).format('DD-MM-YYYY')}</td>
               <td>{row.invoicingTime === null ? " " : moment(row.invoicingTime).format('DD-MM-YYYY')  }</td>
               <td>{row.originDestination}</td>
               <td>{row.mawbMbl}</td>
               <td>{row.hawbHbl}</td>
               <td>{row.customsValue}</td>
               <td>{row.requestingNumber}</td>
               <td>{row.via}</td>
               <td>{row.comertialInvoiceNumber}</td>
               <td>{row.shippingCompany}</td>
               <td>{row.packages}</td>
               <td>{row.weight}</td>
               <td>{row.merchandiseDescription}</td>
               <td>{row.comments}</td>
           </tr>
           ))}
         </tbody>
       </table>
      </div>
    );
  }
}

export default TablesReports;



// WEBPACK FOOTER //
// ./components/data-containers/tableReports.js